import React from 'react';
import { motion } from 'framer-motion';
import logo1 from '../../../Assets/Images/Logo/Deloite.png';
import logo2 from '../../../Assets/Images/Logo/Accenture.png';
import logo3 from '../../../Assets/Images/Logo/Kpmg.png';
import logo4 from '../../../Assets/Images/Logo/Goldman-Sachs.png';
import logo5 from '../../../Assets/Images/Logo/Oracle.png';

const clients = [
  { name: "Deloitte", logo: logo1 },
  { name: "Goldman Sachs", logo: logo4 },
  { name: "Oracle", logo: logo5 },
  { name: "Accenture", logo: logo2 },
  { name: "KPMG", logo: logo3 }
];

export default function ClientMarquee() {
  // Duplicate clients for seamless infinite scroll
  const duplicatedClients = [...clients, ...clients];

  return (
    <div className="relative lg:py-6 ">
      <div className="container mx-auto px-4 relative z-10">
        {/* Marquee Container */}
        <div className="relative">
          {/* Left Gradient Overlay */}
          {/* <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-slate-900 via-slate-900/90 to-transparent z-20 pointer-events-none"></div> */}
          
          {/* Right Gradient Overlay */}
          {/* <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-slate-900 via-slate-900/90 to-transparent z-20 pointer-events-none"></div> */}

          {/* Marquee Wrapper - Desktop */}
          <div className="overflow-hidden hidden md:block">
            <motion.div
              className="flex gap-16 "
              animate={{ x: ["0%", "-100%"] }}
              transition={{
                x: {
                  repeat: Infinity,
                  repeatType: "loop",
                  duration: 30,
                  ease: "linear"
                }
              }}
            >
              {duplicatedClients.map((client, index) => (
                <div
                  key={`${client.name}-${index}`}
                  className="flex-shrink-0"
                >
                  <ClientLogo client={client} />
                </div>
              ))}
            </motion.div>
          </div>

          {/* Mobile View */}
        <div className="md:hidden overflow-hidden w-full">
  <motion.div
    className="flex gap-6"
    animate={{ x: [0, -1000] }}
    transition={{
      repeat: Infinity,
      repeatType: "loop",
      duration: 20,
      ease: "linear",
    }}
  >
    {duplicatedClients.map((client, index) => (
      <div key={index} className="flex-shrink-0">
        <ClientLogo client={client} isMobile={true} />
      </div>
    ))}
  </motion.div>
</div>

        </div>
      </div>
    </div>
  );
}

function ClientLogo({ client, isMobile = false }) {
  return (
    <div className="group">
      {/* Logo Container */}
      <div className={`
        relative  backdrop-blur-sm 
        rounded-2xl px-6 ${isMobile ? 'w-48 h-32' : 'w-56 h-44'}
        flex items-center justify-center 
        transition-all duration-300 
      `}>
        {/* Logo Image */}
        <img
          src={client.logo}
          alt={client.name}
          className={`
            w-full h-full object-contain 
            transition-all duration-500 
            group-hover:scale-110
            ${isMobile ? 'max-h-20' : 'max-h-28'}
          `}
        />
        
        {/* Hover Effect Line */}
        <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-0 h-1 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full transition-all duration-300 group-hover:w-16"></div>
      </div>
    </div>
  );
}